var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictogram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "114px",
    height: "40px",
    viewBox: "0 0 120 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo_web_compatto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_web_compatto",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(59.000000, 2.000000)",
    fill: "#E20D18",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.895,35.64 C8.307,35.64 2.943,30.276 2.943,23.688 C2.943,17.1 8.307,11.736 14.895,11.736 C21.483,11.736 26.847,17.1 26.847,23.688 C26.847,30.285 21.492,35.64 14.895,35.64 Z M14.895,17.775 C11.628,17.775 8.973,20.43 8.973,23.697 C8.973,26.964 11.628,29.619 14.895,29.619 C18.162,29.619 20.817,26.964 20.817,23.697 C20.817,20.43 18.162,17.775 14.895,17.775 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,35.154 L47.736,35.154 L47.736,23.688 C47.736,20.484 45.135,17.883 41.931,17.883 C38.727,17.883 36.126,20.484 36.126,23.688 L36.126,35.154 L29.862,35.154 L29.862,23.688 C29.862,17.037 35.28,11.619 41.931,11.619 C48.582,11.619 54,17.037 54,23.688 L54,35.154 L54,35.154 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.669,10.899 C22.32,7.848 18.612,6.03 14.769,6.03 C10.989,6.03 7.461,7.713 5.076,10.638 L0.396,6.831 C3.933,2.484 9.171,0 14.769,0 C20.475,0 25.965,2.7 29.448,7.209 L24.669,10.899 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E30613",
    x: 0.4,
    y: 0.56,
    width: 34.24,
    height: 34.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.77,14.47 C14.77,14.47 14.43,14.41 13.93,14.19 C10.95,12.84 8.88,10.22 8.93,6.52 L8.93,3.08 L9.43,3.08 C9.43,3.47 9.44,7.29 9.49,7.68 C9.71,10.32 11.79,12.9 14.32,13.86 C14.66,13.97 14.94,14.08 14.94,14.08 C15.08,14.14 15.13,14.24 15.09,14.34 C15.02,14.54 14.77,14.47 14.77,14.47",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88,17.64 L11.86,15.04 C11.92,14.98 12.03,14.87 12.2,14.99 C12.37,15.11 12.32,15.22 12.25,15.32 L10.49,17.65",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.28,17.63 L13.93,15.98 C13.96,15.9 14.08,15.8 14.23,15.86 C14.39,15.93 14.41,16.04 14.38,16.15 L13.79,17.63 L13.28,17.63 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.64,5.54 L18.03,5.54 L18.03,5.43 L16.46,5.43 L16.46,5.54 L16.8,5.54 C16.8,5.76 16.97,5.88 17.19,5.88 C17.41,5.88 17.64,5.77 17.64,5.54",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.79,17.64 L23.81,15.03 C23.75,14.97 23.67,14.84 23.47,14.97 C23.32,15.07 23.37,15.21 23.41,15.31 L25.17,17.64 L25.79,17.64 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.39,17.65 L21.74,15.99 C21.68,15.89 21.62,15.85 21.52,15.88 C21.4,15.91 21.26,15.99 21.3,16.16 L21.89,17.65 L22.39,17.65 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7,16.27 C29.37,15.54 29.99,14.7 30.5,13.86 L26.4,12.06 C26.28,11.99 26.24,11.85 26.33,11.71 C26.4,11.6 26.51,11.56 26.62,11.61 L30.72,13.41 C31.17,12.57 31.56,11.67 31.9,10.72 L27.41,9.93 C27.32,9.91 27.22,9.83 27.26,9.62 C27.3,9.44 27.47,9.42 27.52,9.43 L32.01,10.27 C32.29,9.43 32.46,8.53 32.52,7.58 L27.92,7.58 C27.86,7.58 27.68,7.54 27.68,7.35 C27.68,7.22 27.81,7.13 27.92,7.13 L32.58,7.13 L32.58,6.16 L32.58,3.39 L23.37,3.39 C22.75,3.39 22.25,3.9 22.25,4.51 L22.31,8.8 C22.31,9.36 21.69,9.81 21.24,9.81 L21.24,9.19 L21.86,9.19 L21.19,7.51 L21.86,7.29 L20.79,5.83 L21.24,5.44 L19.56,4.54 L19.9,3.92 C19.9,3.92 19.9,3.98 19.9,3.92 L16.64,3.98 C15.82,4.02 15.74,4.2 15.52,4.6 C15.46,4.77 15.41,4.94 15.35,5.11 C14.62,5.17 13.95,5.28 13.44,5.9 C13.1,6.35 12.99,6.85 13.1,7.47 C13.1,7.53 13.16,7.64 13.27,7.64 C13.38,7.64 13.44,7.47 13.44,7.36 C13.55,6.91 14.06,6.69 14.51,6.57 C14.85,6.51 15.24,6.51 15.52,6.63 C15.86,6.85 15.97,7.11 15.97,7.33 L14.57,7.33 C14.91,7.61 15.24,8.14 15.58,8.48 C15.36,8.93 15.13,9.38 14.96,9.83 L13.84,9.83 C13.22,9.83 12.66,9.27 12.66,8.65 L12.66,4.51 C12.66,3.89 12.15,3.39 11.54,3.39 L2.32,3.39 L2.32,6.11 L2.32,7.06 L6.98,7.12 C7.16,7.12 7.2,7.2 7.2,7.34 C7.2,7.53 7.09,7.56 6.98,7.56 L2.38,7.56 C2.44,8.51 2.6,9.41 2.89,10.25 L7.38,9.41 C7.49,9.41 7.62,9.41 7.66,9.61 C7.7,9.83 7.6,9.88 7.49,9.91 C7.45,9.92 3,10.7 3,10.7 C3.34,11.65 3.67,12.55 4.18,13.39 L8.28,11.59 C8.39,11.53 8.52,11.55 8.6,11.71 C8.71,11.94 8.57,12 8.51,12.04 L4.41,13.84 C4.92,14.68 5.53,15.52 6.21,16.25 L9.75,13.44 C9.81,13.38 9.96,13.37 10.05,13.48 C10.17,13.64 10.09,13.78 10.03,13.83 L6.53,16.6 C6.92,17.05 7.21,17.3 7.7,17.63 L1.1,17.63 L1.1,1.24 L33.95,1.24 L33.95,17.63 L27.2,17.63 C27.71,17.29 27.98,17.05 28.37,16.6 L24.89,13.85 C24.8,13.73 24.78,13.6 24.89,13.5 C25,13.39 25.17,13.45 25.17,13.46 L28.7,16.27 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,3.08 C26.2,3.47 26.19,7.29 26.14,7.68 C25.92,10.32 23.84,12.9 21.31,13.86 C20.97,13.97 20.69,14.08 20.69,14.08 C20.59,14.15 20.52,14.27 20.56,14.37 C20.64,14.54 20.86,14.47 20.86,14.47 C20.86,14.47 21.2,14.41 21.7,14.19 C24.68,12.84 26.75,10.22 26.7,6.52 L26.7,3.08 L26.2,3.08 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 17.3,
    y: 28.93,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 17.3,
    y: 29.93,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.61,28.61 C18.05,28.61 18.37,28.23 18.37,27.79 C18.37,27.35 18.05,27.03 17.61,27.03 C17.17,27.03 16.79,27.35 16.79,27.79 C16.79,28.23 17.17,28.61 17.61,28.61",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,28.48 C18.69,28.29 18.75,28.04 18.75,27.79 L18.75,27.1 L19.07,27.1 L19.07,27.79 C19.07,28.55 18.57,28.86 18.57,28.86 L19.77,30.31 C19.9,30.5 19.77,30.69 19.64,30.69 L19.07,30.69 L19.07,31.89 L18.75,31.89 L18.75,30.69 L18.37,30.69 C18.24,30.69 18.18,30.56 18.18,30.5 L18.18,28.73 C18.18,28.74 18.37,28.61 18.5,28.48",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,30.94 C18.5,31.44 18.12,31.82 17.62,31.82 C17.11,31.82 16.67,31.44 16.67,30.94 L18.5,30.94 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.68,28.48 C16.49,28.29 16.43,28.04 16.43,27.79 L16.43,27.1 L16.11,27.1 L16.11,27.79 C16.11,28.55 16.61,28.86 16.61,28.86 L15.41,30.31 C15.28,30.5 15.41,30.69 15.54,30.69 L16.11,30.69 L16.11,31.89 L16.43,31.89 L16.43,30.69 L16.81,30.69 C16.94,30.69 17,30.56 17,30.5 L17,28.73 C16.99,28.74 16.8,28.61 16.68,28.48",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 25.29,
    y: 26.55,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 25.29,
    y: 27.56,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,26.23 C26.04,26.23 26.36,25.85 26.36,25.41 C26.36,24.97 26.04,24.65 25.6,24.65 C25.16,24.65 24.78,24.97 24.78,25.41 C24.78,25.86 25.16,26.23 25.6,26.23",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.48,26.11 C26.67,25.92 26.73,25.67 26.73,25.42 L26.73,24.73 L27.05,24.73 L27.05,25.42 C27.05,26.18 26.55,26.49 26.55,26.49 L27.75,27.94 C27.88,28.13 27.75,28.32 27.62,28.32 L27.05,28.32 L27.05,29.52 L26.73,29.52 L26.73,28.32 L26.35,28.32 C26.22,28.32 26.16,28.19 26.16,28.13 L26.16,26.36 C26.17,26.36 26.36,26.23 26.48,26.11",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.48,28.57 C26.48,29.07 26.1,29.45 25.6,29.45 C25.1,29.45 24.65,29.07 24.65,28.57 L26.48,28.57 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.66,26.11 C24.47,25.92 24.41,25.67 24.41,25.42 L24.41,24.73 L24.1,24.73 L24.1,25.42 C24.1,26.18 24.6,26.49 24.6,26.49 L23.4,27.94 C23.27,28.13 23.4,28.32 23.53,28.32 L24.1,28.32 L24.1,29.52 L24.42,29.52 L24.42,28.32 L24.8,28.32 C24.93,28.32 24.99,28.19 24.99,28.13 L24.99,26.36 C24.98,26.36 24.79,26.23 24.66,26.11",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 29.24,
    y: 21.66,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 29.24,
    y: 22.67,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.56,21.35 C30,21.35 30.32,20.97 30.32,20.53 C30.32,20.09 30,19.77 29.56,19.77 C29.12,19.77 28.74,20.09 28.74,20.53 C28.74,20.97 29.12,21.35 29.56,21.35",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.44,21.22 C30.63,21.03 30.69,20.78 30.69,20.53 L30.69,19.84 L31.01,19.84 L31.01,20.53 C31.01,21.29 30.51,21.6 30.51,21.6 L31.71,23.05 C31.84,23.24 31.71,23.43 31.58,23.43 L31.01,23.43 L31.01,24.63 L30.69,24.63 L30.69,23.43 L30.31,23.43 C30.18,23.43 30.12,23.3 30.12,23.24 L30.12,21.47 C30.13,21.47 30.31,21.35 30.44,21.22",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.44,23.68 C30.44,24.18 30.06,24.56 29.56,24.56 C29.06,24.56 28.61,24.18 28.61,23.68 L30.44,23.68 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.62,21.22 C28.43,21.03 28.37,20.78 28.37,20.53 L28.37,19.84 L28.05,19.84 L28.05,20.53 C28.05,21.29 28.55,21.6 28.55,21.6 L27.35,23.05 C27.22,23.24 27.35,23.43 27.48,23.43 L28.05,23.43 L28.05,24.63 L28.37,24.63 L28.37,23.43 L28.75,23.43 C28.88,23.43 28.94,23.3 28.94,23.24 L28.94,21.47 C28.94,21.47 28.75,21.35 28.62,21.22",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 21.35,
    y: 21.66,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 21.35,
    y: 22.67,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.66,21.35 C22.1,21.35 22.42,20.97 22.42,20.53 C22.42,20.09 22.1,19.77 21.66,19.77 C21.22,19.77 20.84,20.09 20.84,20.53 C20.84,20.97 21.22,21.35 21.66,21.35",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.55,21.22 C22.74,21.03 22.8,20.78 22.8,20.53 L22.8,19.84 L23.12,19.84 L23.12,20.53 C23.12,21.29 22.62,21.6 22.62,21.6 L23.82,23.05 C23.95,23.24 23.82,23.43 23.69,23.43 L23.12,23.43 L23.12,24.63 L22.8,24.63 L22.8,23.43 L22.42,23.43 C22.29,23.43 22.23,23.3 22.23,23.24 L22.23,21.47 C22.23,21.47 22.42,21.35 22.55,21.22",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.55,23.68 C22.55,24.18 22.17,24.56 21.67,24.56 C21.17,24.56 20.72,24.18 20.72,23.68 L22.55,23.68 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73,21.22 C20.54,21.03 20.48,20.78 20.48,20.53 L20.48,19.84 L20.16,19.84 L20.16,20.53 C20.16,21.29 20.66,21.6 20.66,21.6 L19.46,23.05 C19.33,23.24 19.46,23.43 19.59,23.43 L20.16,23.43 L20.16,24.63 L20.48,24.63 L20.48,23.43 L20.86,23.43 C20.99,23.43 21.05,23.3 21.05,23.24 L21.05,21.47 C21.04,21.47 20.85,21.35 20.73,21.22",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 9.15,
    y: 26.55,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 9.15,
    y: 27.56,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47,26.23 C9.91,26.23 10.23,25.85 10.23,25.41 C10.23,24.97 9.91,24.65 9.47,24.65 C9.03,24.65 8.65,24.97 8.65,25.41 C8.65,25.86 9.03,26.23 9.47,26.23",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.35,26.11 C10.54,25.92 10.6,25.67 10.6,25.42 L10.6,24.73 L10.92,24.73 L10.92,25.42 C10.92,26.18 10.42,26.49 10.42,26.49 L11.62,27.94 C11.75,28.13 11.62,28.32 11.49,28.32 L10.92,28.32 L10.92,29.52 L10.6,29.52 L10.6,28.32 L10.22,28.32 C10.09,28.32 10.03,28.19 10.03,28.13 L10.03,26.36 C10.04,26.36 10.23,26.23 10.35,26.11",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.35,28.57 C10.35,29.07 9.97,29.45 9.47,29.45 C8.96,29.45 8.52,29.07 8.52,28.57 L10.35,28.57 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53,26.11 C8.34,25.92 8.28,25.67 8.28,25.42 L8.28,24.73 L7.97,24.73 L7.97,25.42 C7.97,26.18 8.47,26.49 8.47,26.49 L7.27,27.94 C7.14,28.13 7.27,28.32 7.4,28.32 L7.97,28.32 L7.97,29.52 L8.29,29.52 L8.29,28.32 L8.67,28.32 C8.8,28.32 8.86,28.19 8.86,28.13 L8.86,26.36 C8.85,26.36 8.66,26.23 8.53,26.11",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 13.09,
    y: 21.66,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 13.09,
    y: 22.67,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.41,21.35 C13.85,21.35 14.17,20.97 14.17,20.53 C14.17,20.09 13.85,19.77 13.41,19.77 C12.97,19.77 12.59,20.09 12.59,20.53 C12.59,20.97 12.97,21.35 13.41,21.35",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.29,21.22 C14.48,21.03 14.54,20.78 14.54,20.53 L14.54,19.84 L14.86,19.84 L14.86,20.53 C14.86,21.29 14.36,21.6 14.36,21.6 L15.56,23.05 C15.69,23.24 15.56,23.43 15.43,23.43 L14.86,23.43 L14.86,24.63 L14.54,24.63 L14.54,23.43 L14.16,23.43 C14.03,23.43 13.97,23.3 13.97,23.24 L13.97,21.47 C13.98,21.47 14.16,21.35 14.29,21.22",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.29,23.68 C14.29,24.18 13.91,24.56 13.41,24.56 C12.9,24.56 12.46,24.18 12.46,23.68 L14.29,23.68 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.47,21.22 C12.28,21.03 12.22,20.78 12.22,20.53 L12.22,19.84 L11.9,19.84 L11.9,20.53 C11.9,21.29 12.4,21.6 12.4,21.6 L11.2,23.05 C11.07,23.24 11.2,23.43 11.33,23.43 L11.9,23.43 L11.9,24.63 L12.22,24.63 L12.22,23.43 L12.6,23.43 C12.73,23.43 12.79,23.3 12.79,23.24 L12.79,21.47 C12.79,21.47 12.6,21.35 12.47,21.22",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 5.24,
    y: 21.66,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 5.24,
    y: 22.67,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55,21.35 C5.99,21.35 6.31,20.97 6.31,20.53 C6.31,20.09 5.99,19.77 5.55,19.77 C5.11,19.77 4.73,20.09 4.73,20.53 C4.73,20.97 5.11,21.35 5.55,21.35",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44,21.22 C6.63,21.03 6.69,20.78 6.69,20.53 L6.69,19.84 L7,19.84 L7,20.53 C7,21.29 6.5,21.6 6.5,21.6 L7.7,23.05 C7.83,23.24 7.7,23.43 7.57,23.43 L7,23.43 L7,24.63 L6.69,24.63 L6.69,23.43 L6.31,23.43 C6.18,23.43 6.12,23.3 6.12,23.24 L6.12,21.47 C6.12,21.47 6.31,21.35 6.44,21.22",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44,23.68 C6.44,24.18 6.06,24.56 5.56,24.56 C5.05,24.56 4.61,24.18 4.61,23.68 L6.44,23.68 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62,21.22 C4.43,21.03 4.37,20.78 4.37,20.53 L4.37,19.84 L4.05,19.84 L4.05,20.53 C4.05,21.29 4.55,21.6 4.55,21.6 L3.35,23.05 C3.22,23.24 3.35,23.43 3.48,23.43 L4.05,23.43 L4.05,24.63 L4.37,24.63 L4.37,23.43 L4.75,23.43 C4.88,23.43 4.94,23.3 4.94,23.24 L4.94,21.47 C4.93,21.47 4.74,21.35 4.62,21.22",
    id: "Path",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 0,
    x2: 47,
    y2: 40,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogram);
export default __webpack_public_path__ + "static/media/Pictogram.d0baeef574ca38440d23c0bb92626320.svg";
export { ForwardRef as ReactComponent };